import React from "react";
import "./ContactConversationSection.css";
import { FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";
import { SiMeta } from "react-icons/si";

const ContactSocialConversationSection = () => {
  return (
    <section className="vcnr-social-convo-wrapper">
      <div className="vcnr-social-section">
        <div className="vcnr-social-item">
          <p>/ VCNR Group</p>
          <SiMeta className="vcnr-social-icon" />
        </div>
        <div className="vcnr-social-item">
          <p>/ VCNR Group</p>
          <FaInstagram className="vcnr-social-icon" />
        </div>
        <div className="vcnr-social-item">
          <p>/ VCNR Group</p>
          <FaTwitter className="vcnr-social-icon" />
        </div>
        <div className="vcnr-social-item">
          <p>/ VCNR Group</p>
          <FaLinkedin className="vcnr-social-icon" />
        </div>
      </div>

      <div className="vcnr-conversation-section">
        <h2 className="vcnr-conversation-heading">
          Ready to start a conversation that could shape the future?
        </h2>
        <p className="vcnr-conversation-email">info@vcnrworld.com</p>
        <div className="vcnr-button-group">
          <button className="vcnr-btn">Start a Conversation</button>
          <button className="vcnr-btn vcnr-outline-btn">
            Download Group Profile PDF
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactSocialConversationSection;
